import { RenderElementProps } from 'slate-react';

export interface QuestionStyleOptions {
  isReadOnly?: boolean;
}

export interface BaseQuestionStyleProps extends RenderElementProps, QuestionStyleOptions {}

export const ELEMENT_QUESTION_STYLE = 'question-style';
